'use client';

import { useCallback } from 'react';

type PermissionTree = {
  handle: string;
  id: string;
  status: number;
  children: PermissionTree[];
};

const usePaymentPermissions = (tree: PermissionTree[]) => {
  const hasPaymentPermission = useCallback(
    (
      paymentMethodTypeHandle: string,
      transactionTypeHandle: string,
      assetHandle: string
    ) => {
      const method = tree.find(
        ({ handle }) => handle === paymentMethodTypeHandle
      );
      if (!method) return false;

      const transactionType = method.children.find(
        ({ handle }) => handle === transactionTypeHandle
      );
      if (!transactionType) return false;

      const asset = transactionType.children.find(
        ({ handle }) => handle === assetHandle
      );
      if (!asset) return false;

      return !!asset.status;
    },
    [tree]
  );

  return hasPaymentPermission;
};

export default usePaymentPermissions;
